import React from "react";
import PropTypes from "prop-types";

/**
 * Avatar de usuario: muestra imagen si existe, o iniciales con gradiente si no.
 * @param {string} src - URL de la imagen del avatar
 * @param {string} name - Nombre para generar iniciales
 * @param {string} size - "sm" | "md" | "lg" | "xl"
 * @param {string} className - Clases adicionales
 */
const Avatar = ({ src, name = "Usuario", size = "md", className = "" }) => {
  const initials = (name || "U")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const sizeClasses = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-20 h-20 text-2xl",
    xl: "w-24 h-24 text-3xl"
  };

  const commonClasses = `rounded-full overflow-hidden flex-shrink-0 ring-2 ring-gray-200 dark:ring-gray-700 ${sizeClasses[size]} ${className}`.trim();

  if (src?.trim()) {
    return <img src={src} alt={name} className={`${commonClasses} object-cover`} />;
  }

  return (
    <div className={`${commonClasses} flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-500 text-white font-semibold`}>
      {initials}
    </div>
  );
};

Avatar.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  className: PropTypes.string
};

export default Avatar;
